// MUI components
import { useState, useContext, useEffect } from 'react'
import { IntakeContext } from '../context/IntakeContext'

import { toast } from 'react-toastify'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'

import { Button, Box, Grid, Typography } from '@mui/material'

import { format, subYears, differenceInYears } from 'date-fns'
import { MuiSplitDateField } from './FormField/MuiSplitDateField'

const OnboardingSpouse = () => {
  const { intakeState, updateIntakeStateAtKey, updateUser } =
    useContext(IntakeContext)
  const [ageQuestion, setAgeQuestion] = useState(false) // 👈 default is Age now

  const dateToYears = intakeState.familySpouseDateOfBirth
    ? differenceInYears(
        new Date(),
        new Date(intakeState.familySpouseDateOfBirth)
      )
    : ''
  const yearsToDate = (years) =>
    format(subYears(new Date(), years), 'yyyy-MM-dd')

  const onSubmit = () => {
    updateUser()
    toast.info('You have successfully updated your user profile', {
      position: 'top-center',
      autoClose: 5000,
      pauseOnFocusLoss: false,
      pauseOnHover: false,
    })
  }

  useEffect(() => {
    if (!intakeState.familySpouseLastName && intakeState.lastName) {
      updateIntakeStateAtKey({ familySpouseLastName: intakeState.lastName })
    }
  }, [intakeState.familySpouseLastName, intakeState.lastName])

  return (
    <Box sx={{ textAlign: 'left' }}>
      <Box mb={1}>
        <Typography variant="h4" fontSize={{ xs: '20px', sm: '24px' }}>
          Tell Us About Your Spouse!
        </Typography>
      </Box>
      <Box component="form" py={3}>
        <Box mt={3} mb={2}>
          <Typography variant="body1Medium">Spouse's Name</Typography>
        </Box>

        <Grid container columnSpacing={3} rowSpacing={2}>
          <Grid item xs={12}>
            {renderMuiFormField({
              id: 'familySpouseFirstName',
              label: `First Name`,
              placeholder: `First Name`,
              tooltip: {
                title: `Providing your spouse's name tells us who should receive death benefits.`,
              },
              inputType: 'text',
              value: intakeState.familySpouseFirstName,
              onChange: (familySpouseFirstName) =>
                updateIntakeStateAtKey({ familySpouseFirstName }),
            })}
          </Grid>
          <Grid item xs={12}>
            {renderMuiFormField({
              id: 'familySpouseLastName',
              label: `Last Name`,
              placeholder: `Last Name`,
              tooltip: {
                title: `Providing your spouse's name tells us who should receive death benefits.`,
              },
              inputType: 'text',
              value: intakeState.familySpouseLastName,
              onChange: (familySpouseLastName) =>
                updateIntakeStateAtKey({ familySpouseLastName }),
            })}
          </Grid>

          {!ageQuestion ? (
            <>
              <Typography variant="body1Medium" mt={3} px={3}>
                Spouse's Age
              </Typography>

              <Grid item xs={12}>
                {renderMuiFormField({
                  inputType: 'int',
                  id: 'age',
                  label: 'Age',
                  value: dateToYears,
                  onChange: (e) => {
                    updateIntakeStateAtKey({
                      familySpouseDateOfBirth: yearsToDate(e),
                    })
                  },
                })}
                <Button
                  variant="text"
                  color="info"
                  onClick={() => setAgeQuestion(true)}
                >
                  Use their date of birth instead
                </Button>
              </Grid>
            </>
          ) : (
            // Toggle: DOB input
            <>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  flexDirection="column"
                  justifyContent="flex-end"
                  height="100%"
                >
                  <Typography variant="body1Medium">
                    Spouse's Date of Birth
                  </Typography>
                  <MuiSplitDateField
                    id="spouseDOB"
                    // label="Spouse's Date of Birth"
                    value={intakeState.familySpouseDateOfBirth}
                    onChange={(date) => {
                      updateIntakeStateAtKey({
                        familySpouseDateOfBirth: date,
                      })
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box display="flex" justifyContent="flex-start">
                  <Button
                    variant="text"
                    color="info"
                    sx={{ height: '100%' }}
                    onClick={() => setAgeQuestion(false)}
                  >
                    Use their age instead
                  </Button>
                </Box>
              </Grid>
            </>
          )}
        </Grid>
      </Box>
    </Box>
  )
}

export default OnboardingSpouse
